import Vue from 'vue'

const KyeDropdown = Vue.component('kye-dropdown', {
  functional: true,
  render (h, self) {
    return h(
      'el-dropdown',
      self.data,
      self.children && self.children.map(t => {
        if (t.data && t.data.attrs) {
          t.data.attrs = { ...t.data.attrs, ...(t.componentOptions && t.componentOptions.propsData) }
        }
        if (t.data && t.data.on === undefined) {
          t.data.on = t.data.on || (t.componentOptions && t.componentOptions.listeners)
        }
        return h(
          (t.componentOptions && t.componentOptions.tag) || t.tag,
          t.data,
          t.children || (t.componentOptions && t.componentOptions.children)
        )
      })
    )
  }
})

export default KyeDropdown



// WEBPACK FOOTER //
// ./src/public/components/kye-dropdown/index.js